// Vocabulary Questions - Original questions for SpeakUp Placement Test
// 20 questions covering A1 to C1 levels

export const vocabularyQuestions = [
  // A1 Level Questions (31-37)
  {
    id: 31,
    section: 'vocabulary',
    question: 'I need to buy some _____ for breakfast.',
    options: ['bread', 'stone', 'paper', 'metal'],
    correct: 0,
    level: 'A1'
  },
  {
    id: 32,
    section: 'vocabulary',
    question: 'What _____ is it? I forgot my watch.',
    options: ['day', 'time', 'year', 'weather'],
    correct: 1,
    level: 'A1'
  },
  {
    id: 33,
    section: 'vocabulary',
    question: 'She is wearing a beautiful red _____.',
    options: ['dress', 'floor', 'wall', 'roof'],
    correct: 0,
    level: 'A1'
  },
  {
    id: 34,
    section: 'vocabulary',
    question: 'My _____ is on Main Street.',
    options: ['house', 'sky', 'cloud', 'tree'],
    correct: 0,
    level: 'A1'
  },
  {
    id: 35,
    section: 'vocabulary',
    question: 'Can you _____ the door, please?',
    options: ['close', 'make', 'do', 'put'],
    correct: 0,
    level: 'A1'
  },
  {
    id: 36,
    section: 'vocabulary',
    question: 'I _____ my homework every evening.',
    options: ['make', 'do', 'take', 'give'],
    correct: 1,
    level: 'A1'
  },
  {
    id: 37,
    section: 'vocabulary',
    question: 'The _____ is shining today. It\'s a beautiful day!',
    options: ['moon', 'sun', 'rain', 'snow'],
    correct: 1,
    level: 'A1'
  },

  // A2 Level Questions (38-43)
  {
    id: 38,
    section: 'vocabulary',
    question: 'I need to _____ a reservation at the restaurant.',
    options: ['do', 'make', 'take', 'have'],
    correct: 1,
    level: 'A2'
  },
  {
    id: 39,
    section: 'vocabulary',
    question: 'The company will _____ 20 new employees next month.',
    options: ['rent', 'borrow', 'hire', 'lend'],
    correct: 2,
    level: 'A2'
  },
  {
    id: 40,
    section: 'vocabulary',
    question: 'I\'m trying to _____ weight, so I go to the gym every day.',
    options: ['lose', 'loose', 'miss', 'fall'],
    correct: 0,
    level: 'A2'
  },
  {
    id: 41,
    section: 'vocabulary',
    question: 'She gave me some good _____ about my career.',
    options: ['advice', 'advise', 'idea', 'opinion'],
    correct: 0,
    level: 'A2'
  },
  {
    id: 42,
    section: 'vocabulary',
    question: 'The price of food has _____ significantly this year.',
    options: ['fallen', 'decreased', 'increased', 'lowered'],
    correct: 2,
    level: 'A2'
  },
  {
    id: 43,
    section: 'vocabulary',
    question: 'Could you _____ me a favor and help with this box?',
    options: ['do', 'make', 'give', 'take'],
    correct: 0,
    level: 'A2'
  },

  // B1 Level Questions (44-47)
  {
    id: 44,
    section: 'vocabulary',
    question: 'The new policy will _____ everyone in the company.',
    options: ['effect', 'affect', 'infect', 'reflect'],
    correct: 1,
    level: 'B1'
  },
  {
    id: 45,
    section: 'vocabulary',
    question: 'She\'s very _____ and always thinks about other people.',
    options: ['selfish', 'thoughtful', 'careless', 'reckless'],
    correct: 1,
    level: 'B1'
  },
  {
    id: 46,
    section: 'vocabulary',
    question: 'The results of the study were quite _____.',
    options: ['surprising', 'surprised', 'surprise', 'surprisingly'],
    correct: 0,
    level: 'B1'
  },
  {
    id: 47,
    section: 'vocabulary',
    question: 'We need to _____ a solution to this problem quickly.',
    options: ['find out', 'come up with', 'look after', 'get over'],
    correct: 1,
    level: 'B1'
  },

  // B2 Level Questions (48-49)
  {
    id: 48,
    section: 'vocabulary',
    question: 'The company\'s profits have been _____ declining for three years.',
    options: ['steadily', 'hardly', 'rarely', 'barely'],
    correct: 0,
    level: 'B2'
  },
  {
    id: 49,
    section: 'vocabulary',
    question: 'The government implemented new measures to _____ climate change.',
    options: ['tackle', 'handle', 'manage', 'control'],
    correct: 0,
    level: 'B2'
  },

  // C1 Level Question (50)
  {
    id: 50,
    section: 'vocabulary',
    question: 'The politician\'s speech was full of _____ promises that nobody believed.',
    options: ['hollow', 'empty', 'blank', 'void'],
    correct: 0,
    level: 'C1'
  }
];
